import React, { useEffect, useState } from "react";
import "../style/page/doctorview.scss";
import { useSelector, useDispatch } from "react-redux";
import {
  editdoctoruser,
  editdoctoruserid,
  dvtabs,
} from "../redux/reducer/counterslice";
import axios from "axios";
import { doctorlist, spacilitylist } from "../../text/apidata";
import { useNavigate } from "react-router-dom";
import BaseTimeForm from "../form/tabs/basetimeform";
import TimeSlot from "./tabs/timeslot";
import Appoinment from "./tabs/appoinments";
import BaseTime from "./tabs/basetime";
import noimage from "../../assets/images/no-photo-available-icon-4.jpg";
import NotAvailable from "./tabs/Notavailable";
export default function DoctorView(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const [gender, setGender] = React.useState("");
  const [type, settype] = React.useState("");
  const [mr, setmr] = useState("");
  const [doctorspacilityselected, setdoctorspacilityselected] = useState([]);
  const [selected, setSelected] = useState([]);
  const [language, setlanguage] = useState([]);
  const editdoctoruserselect = useSelector(
    (state) => state.counter.editdoctoruser
  );
  const activebtf = useSelector((state) => state.counter.basetimeedit);
  const minisbstate = useSelector((state) => state.counter.minisidebar);
  console.log(doctorspacilityselected);
  const [createmailvalue, setCreatEmailvalue] = useState("");
  const [creatfirstname, setCreatefirstname] = useState("");
  const [createfees, setCreatefees] = useState("");
  const [creatlastname, setCreatelastname] = useState("");
  const [creatphoneno, setCreatephoneno] = useState("");
  const [createxperience, setCreateexperience] = useState("");
  const [creatgender, setCreategender] = useState("");
  const [getemail, setgetemail] = useState();
  const editdoctorid = useSelector((state) => state.counter.edituserdoctorid);
  const [url, setUrl] = useState();
  const editadminuserform = useNavigate();
  const [checked, setChecked] = React.useState(true);
  const [doctorid, setdoctorid] = useState("");
  const dispatch = useDispatch();
  const edituserdoctoridvalue = useDispatch();
  const [tab, settab] = useState("About");
  const subtabs = useSelector((state) => state.counter.dvtabs);
  const tabsstate = useDispatch();
  useEffect(() => {
    // console.log(editdoctorid)
    props.loaderchange("true");
    axios({
      method: "get",
      url: doctorlist + editdoctorid + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data.data);
        if (res.status == 200) {
          let spacilityArray = [];
          // console.log(res.data.status.code);
          if (res.data.status.code) {
            res.data.data.speciality.forEach((element) => {
              // console.log(element.name, element.id);
              spacilityArray.push(element.name);
            });
            setdoctorspacilityselected(spacilityArray);
          }
          setGender(res.data.data.gender);
          settype(res.data.data.type);
          setgetemail(res.data.data.email);
          let putspacility = [];
          res.data.data.speciality.forEach((element) => {
            // console.log(element.id,"id")
            putspacility.push(element.id);
          });
          setCreatEmailvalue(res.data.data.email);
          setCreatefirstname(res.data.data.first_name);
          setCreatefees(res.data.data.fees);
          setCreatelastname(res.data.data.last_name);
          setCreatephoneno(res.data.data.phonenumber);
          setCreateexperience(res.data.data.experience);
          setCreategender(res.data.data.gender);
          setSelected(res.data.data.doctor_qualifications);
          setlanguage(res.data.data.languages_known);
          // setCreatPasswordValue(res.data.data.password)
          setChecked(res.data.data.is_active);
          settype(res.data.data.type);
          setmr(res.data.data.titles);
          setUrl(res.data.data.profile_pic);

          props.loaderchange("false");
        }
      })
      .catch((error) => {
        // console.log(creatdoctorinfo, editdoctorid);
        console.log(error);
        props.loaderchange("false");
      });
    // props.loaderchange("true");
    // axios({
    //   method: "get",
    //   url: spacilitylist,

    //   headers: {
    //     Authorization: "Bearer " + localStorage.getItem("token") + "",
    //   },
    // })
    //   .then((res) => {
    //     let objectArray = [];
    //     // console.log(res.data);
    //     if (res.data.status.code) {
    //       res.data.data.forEach((element) => {
    //         // console.log(element.name, element.id);
    //         objectArray.push({ key: element.id, cat: element.name });
    //       });
    //       setdoctorspacility(objectArray);
    //     }
    //     props.loaderchange("false");
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     props.loaderchange("false");
    //   });
  }, [editdoctoruserselect, minisbstate]);

  const onclick = () => {
    editadminuserform("/DoctorCreate");
    dispatch(editdoctoruser("activedoctoredit"));
    edituserdoctoridvalue(editdoctoruserid(editdoctorid));
    tabsstate(dvtabs("About"));
  };

  const tabclick = (e) => {
    console.log(tab, subtabs);
    console.log(e.target.innerText);
    settab(e.target.innerText);
    tabsstate(dvtabs(e.target.innerText));
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };

  return (
    <>
      <div className={sideactive ? "doc-view-sa" : "doc-view"}>
        <div className="page-wrapper">
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">Profile</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Dashboard
                      </a>
                    </li>
                    <li className="breadcrumb-item">
                      <a
                        href="/Doctor"
                        style={{ textDecoration: "none", color: "black" }}
                      >
                        Doctor
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Profile</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="col-auto profile-image">
                      <a>
                        <img
                          className=""
                          alt="User Image"
                          // style={{borderRadius:"50%"}}
                          src={url ? url : noimage}
                        />
                      </a>
                    </div>
                    <div className="col ml-md-n2 profile-user-info">
                      <h4 className="user-name mb-0">
                        {mr + "." + creatfirstname + " " + creatlastname}
                      </h4>
                      <h6 className="text-muted">{getemail}</h6>
                      {/* <div className="user-Location"><i className="fa fa-map-marker" /> Florida, United States</div>
              <div className="about-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</div> */}
                    </div>
                    <div className="col-auto profile-btn">
                      <a
                        className="btn btn-primary editview"
                        onClick={(e) => onclick(e)}
                      >
                        Edit
                      </a>
                    </div>
                  </div>
                </div>
                <div className="profile-menu">
                  <ul
                    className="nav nav-tabs"
                    role="tablist"
                    style={{
                      backgroundColor: "white",
                      // boxShadow:
                      //   "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
                      height: "50px",
                      // borderRadius: 10,
                      // border:"none"
                      borderBottom: "1px solid #f0f0f0",
                    }}
                  >
                    {" "}
                    <button
                      // class="nav-link active about"
                      className={`nav-link${subtabs == "About" ? " active" : ""
                        } about`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="true"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      About
                    </button>
                    <button
                      // class="nav-link basetime"
                      className={`nav-link${subtabs == "BaseTime" ? " active" : ""
                        } basetime`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      BaseTime
                    </button>
                    <button
                      className={`nav-link${subtabs == "Timeslot" ? " active" : ""
                        } timeslot`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Timeslot
                    </button>
                    <button
                      className={`nav-link${subtabs == "Appoinment" ? " active" : ""
                        } appoinmenttab`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Appoinment
                    </button>
                    <button
                      className={`nav-link${subtabs == "Not Available" ? " active" : ""
                        } notavailabletab`}
                      id="nav-home-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-home"
                      type="button"
                      role="tab"
                      aria-controls="nav-home"
                      aria-selected="false"
                      href="#password_tab"
                      onClick={(e) => tabclick(e)}
                      style={{ marginRight: "10px" }}
                    >
                      Not Available
                    </button>
                  </ul>
                </div>

                {subtabs == "About" ? (
                  <>
                    <div className="tab-content profile-tab-cont">
                      <div
                        className="tab-pane fade show active"
                        id="per_details_tab"
                      >
                        {/* Personal Details */}
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="card">
                              <div className="card-body">
                                <h5 className="card-title d-flex justify-content-between">
                                  <span>Personal Details</span>
                                  <a
                                    className="edit-link"
                                    data-toggle="modal"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => onclick(e)}
                                  >
                                    {/* <i class="bi bi-pencil-fill"></i> Edit */}
                                  </a>
                                </h5>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Name :
                                  </p>
                                  <p className="col-sm-10">
                                    {mr + "." + creatfirstname + creatlastname}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Email ID :
                                  </p>
                                  <p className="col-sm-10">{getemail}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Qualifications :
                                  </p>
                                  <p className="col-sm-10">{`${selected}`}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Mobile :
                                  </p>
                                  <p className="col-sm-10">{creatphoneno}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Experience :
                                  </p>
                                  <p className="col-sm-10">{createxperience}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Gender :
                                  </p>
                                  <p className="col-sm-10">
                                    {creatgender == 0
                                      ? "Male"
                                      : creatgender == 1
                                        ? "Female"
                                        : creatgender == 2
                                          ? "Others"
                                          : creatgender == 3
                                            ? "Decline to State"
                                            : ""}
                                  </p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Languages :
                                  </p>
                                  <p className="col-sm-10">{`${language}`}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Doctor Spacility :
                                  </p>
                                  <p className="col-sm-10">{`${doctorspacilityselected}`}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Doctor Fees :
                                  </p>
                                  <p className="col-sm-10">{`₹${createfees}`}</p>
                                </div>
                                <div className="row">
                                  <p className="col-sm-2 text-muted text-sm-right mb-0 mb-sm-3">
                                    Type :
                                  </p>
                                  <p className="col-sm-10">
                                    {type == 0 ? "Online" : "Hospital Visit"}
                                  </p>
                                </div>

                                {/* <div className="row">
                      <p className="col-sm-2 text-muted text-sm-right mb-0">Address</p>
                      <p className="col-sm-10 mb-0">4663  Agriculture Lane,<br />
                        Miami,<br />
                        Florida - 33165,<br />
                        United States.</p>
                    </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* /Personal Details */}
                      </div>
                    </div>
                  </>
                ) : subtabs == "BaseTime" ? (
                  <>
                    <div className="row" style={{ marginTop: 20 }}>
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">
                            <BaseTime
                              loaderchange={loaderchangechild}
                              popupalert={popupalertchild}
                              popuptext={popuptextchild}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : subtabs == "Timeslot" ? (
                  <>
                    <div className="row" style={{ marginTop: 20 }}>
                      <div className="col-lg-12">
                        <div className="card" style={{ height: "400px" }}>
                          <div className="card-body">
                            <TimeSlot
                              loaderchange={loaderchangechild}
                              popupalert={popupalertchild}
                              popuptext={popuptextchild}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : subtabs == "Appoinment" ? (
                  <>
                    <div className="row" style={{ marginTop: 20 }}>
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">
                            <Appoinment
                              loaderchange={loaderchangechild}
                              popupalert={popupalertchild}
                              popuptext={popuptextchild}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row" style={{ marginTop: 20 }}>
                      <div className="col-lg-12">
                        <div className="card">
                          <div className="card-body">
                            <NotAvailable
                              loaderchange={loaderchangechild}
                              popupalert={popupalertchild}
                              popuptext={popuptextchild}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {activebtf == "btfactive" ? (
        <BaseTimeForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
    </>
  );
}
